module.exports = __webpack_public_path__ + "static/media/purple_icon.219c8110.svg";